/**************************************************
 * Nombre:       Home_Agenda_Cita
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import {theme} from "../../../Tema";
import logo from '../../../Recursos/Logos/logo_blanco.svg'
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";


const Home_Agenda_Cita = () => {
    const {sCell} = useResponsive();

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                backgroundColor: theme.palette.primary.main
            }}
        >

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3, py: 8}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'center'}
                        size={{xs: 12, sm: 12, md: 12}}
                        sx={{color: '#fff'}}
                        spacing={4}
                    >

                        <Grid container size={{xs: 12, sm: 12, md: 2}} sx={{justifyContent: sCell ? 'center' : 'flex-start'}}>
                            <img src={logo} width={120} height={'auto'}/>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 7}} sx={{justifyContent: sCell ? 'center' : 'flex-start'}}>
                            <Typography sx={{textAlign: sCell ? 'center' : 'left'}}>
                                Agendar tu cita gratis es simplemente el paso clave para cuidar tu salud visual y
                                archivos de diagnóstico. Agendar tu cita gratis ha sido el beneficio preferido de
                                nuestros clientes desde el primer día
                            </Typography>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 3}} sx={{justifyContent: sCell ? 'center' : 'flex-end'}}>
                            <Button variant={'outlined'} color={'secondary'}>
                                AGENDA TU CITA GRATIS
                            </Button>
                        </Grid>


                    </Grid>
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Home_Agenda_Cita